import React from 'react'
import { Link } from "react-router-dom";

function FirstPage() {
    return (
        <>
            <div className="login-page" style={{backgroundColor: '#337ab7', textAlign:'center'}}>
                

                <div className="row" style={{backgroundColor:'#337ab7'}} >
                    <div className="col-9">
                <h2 style={{color:'#fff', fontWeight:'bold', marginTop:'10px'}}>GSTAT Deputation Application Portal</h2>
                </div>

                <div className="col-3"><img style={{height:'70px'}} src="https://gstn.org.in/gstat-online-application/assets/img/logo.jfif"/></div>
                </div>
                <div className="login-page9-wrapper"  style={{width:'100%'}}>
                       
                            
                           
                       
                    
                            <div className="col-sm-12 grid-margin stretch-card">
                                <div className="card" style={{padding:'10px'}}>
                                    
   <p style={{textAlign: 'left'}}>The Goods and Services Tax Appellate Tribunal (GSTAT) has been constituted by the Central Government under section 109 of the Central Goods and Services Tax Act, 2017 for hearing appeals against orders passed by the Appellate Authorities or the Revisional Authorities under the Act. The Principal Bench of the GSTAT is located at at New Delhi and there shall be State Benches located in different States.
   </p>
    {/* <p style={{textAlign: 'left'}}>This website has been developed to enable online applications for appointment as Technical Member (State) to the different State Benches of the Tribunal by persons eligible for such appointment.</p> */}
    <p style={{textAlign: 'left'}}>It has been decided to fill the posts of the subordinate staff for the GSTAT Tribunals on deputation basis. Accordingly, one time exemption from UPSC has been sought for filling up the said posts on deputation basis. The detailed vacancy circular, containing the vacancy position and the detailed terms and conditions can be accessed <a href="./Vacancy_Circular.pdf" target="_blank">here</a>.</p>
    <p style={{textAlign: 'left'}}>This website has been developed to enable online applications for appointment for the subordinate staff to the different Benches of the Tribunal by persons eligible for such deputation.</p>
    
    <p style={{textAlign: 'left'}}><b>In case of any difficulty kindly mail to: <Link to="mailto:support.gstat@gstn.org.in">support.gstat@gstn.org.in</Link> </b></p>
    
    <p style={{textAlign: 'left'}}><b><Link to="/login">Click Here to Apply</Link></b></p><br/>
     {/* <div className="form_closed" style={{border: '1px solid black',padding:'5px',fontWeight: 'bold'}}> */}
        {/* <marquee><p>Application filling has been closed and any application filed now will not be entertained.</p></marquee> */}
    {/* </div> */}
    <p style={{textAlign:'left'}}>Important Notice for Applicants: Please be advised that applications on the portal will open starting <b>15.09.2024</b>. We appreciate your patience and look forward to your participation. Thank you for your time and cooperation.</p>
<br/>
   
                                    </div>
                                </div>
                            </div>
    <div className="row">
        <div className="col-3"><p style={{color:'#fff'}}>© 2023-24 Goods and Services Tax Network</p></div>
        <div className="col-6"><p style={{color:'#fff'}}>Version 1.0</p></div>
        <div className="col-3"><p style={{color:'#fff'}}>Designed & Developed by GSTN</p></div>

        </div>
                        </div>


        
 
            
        </>
    )
}

export default FirstPage